// extracted by mini-css-extract-plugin
export default {"container":"Info_container__Y8ORe","title":"Info_title__u1DqQ","content":"Info_content__6Pe9Q"};